const eqQuestions = [
    // Self-Awareness (Q1-5)
    {
        question: "I am usually aware of how I am feeling in any given moment.",
        options: ["Strongly Disagree", "Disagree", "Neutral", "Agree", "Strongly Agree"]
    },
    {
        question: "I understand the link between my emotions and my behavior.",
        options: ["Strongly Disagree", "Disagree", "Neutral", "Agree", "Strongly Agree"]
    },
    {
        question: "I am aware of my strengths and weaknesses.",
        options: ["Strongly Disagree", "Disagree", "Neutral", "Agree", "Strongly Agree"]
    },
    {
        question: "I can accurately describe my feelings when they arise.",
        options: ["Strongly Disagree", "Disagree", "Neutral", "Agree", "Strongly Agree"]
    },
{
    question: "I recognize how my emotions influence my interactions with others.",
    options: ["Strongly Disagree", "Disagree", "Neutral", "Agree", "Strongly Agree"]
},

    // Self-Regulation (Q6-10)
    {
        question: "I can calm myself down quickly when I get angry or upset.",
        options: ["Strongly Disagree", "Disagree", "Neutral", "Agree", "Strongly Agree"]
    },
    {
        question: "I think before I act on my impulses.",
        options: ["Strongly Disagree", "Disagree", "Neutral", "Agree", "Strongly Agree"]
    },
    {
        question: "I can stay focused even under pressure.",
        options: ["Strongly Disagree", "Disagree", "Neutral", "Agree", "Strongly Agree"]
    },
    {
        question: "I am able to control my temper when provoked.",
        options: ["Strongly Disagree", "Disagree", "Neutral", "Agree", "Strongly Agree"]
    },
{
    question: "I take responsibility for my emotional reactions and learn from them.",
    options: ["Strongly Disagree", "Disagree", "Neutral", "Agree", "Strongly Agree"]
},

    // Motivation (Q11-15)
    {
        question: "I set high standards for myself and work hard to achieve them.",
        options: ["Strongly Disagree", "Disagree", "Neutral", "Agree", "Strongly Agree"]
    },
    {
        question: "I am driven by personal goals rather than just rewards.",
        options: ["Strongly Disagree", "Disagree", "Neutral", "Agree", "Strongly Agree"]
    },
    {
        question: "I remain optimistic even when facing setbacks.",
        options: ["Strongly Disagree", "Disagree", "Neutral", "Agree", "Strongly Agree"]
    },
    {
        question: "I am willing to take risks to improve my performance.",
        options: ["Strongly Disagree", "Disagree", "Neutral", "Agree", "Strongly Agree"]
    },
    {
        question: "I am proactive in seeking out new opportunities.",
        options: ["Strongly Disagree", "Disagree", "Neutral", "Agree", "Strongly Agree"]
    },

    // Empathy & Social Skills (Q16-20)
    {
        question: "I can easily sense the emotions of others.",
        options: ["Strongly Disagree", "Disagree", "Neutral", "Agree", "Strongly Agree"]
    },
    {
        question: "I am a good listener and try to understand others' perspectives.",
        options: ["Strongly Disagree", "Disagree", "Neutral", "Agree", "Strongly Agree"]
    },
    {
        question: "I can build rapport easily with new people.",
        options: ["Strongly Disagree", "Disagree", "Neutral", "Agree", "Strongly Agree"]
    },
    {
        question: "I am skilled at resolving conflicts within a group.",
        options: ["Strongly Disagree", "Disagree", "Neutral", "Agree", "Strongly Agree"]
    },
{
    question: "I consider how my decisions may affect other people.",
    options: ["Strongly Disagree", "Disagree", "Neutral", "Agree", "Strongly Agree"]
}
];

export default eqQuestions;
